// collection page filtering

const filterButton = document.querySelector('.collection-toolbar__filter');
const overlay = document.getElementById('collection-overlay');

if (filterButton){
  filterButton.addEventListener('mouseenter', function() {
    overlay.style.display = 'block';
    setTimeout(() => {
      overlay.style.opacity = '1';
    }, 10);
  });

  filterButton.addEventListener('mouseleave', function() {
    overlay.style.opacity = '0';
    setTimeout(() => {
      overlay.style.display = 'none';
    }, 100);
  });
}

// applying and resetting filter
function submitCollectionFiltersForm() {
  const formData = new FormData(document.getElementById('collectionFiltersForm'));
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams();

  // store 'sort_by' value to append it at the end
  const sortValue = formData.get('sort_by');
  formData.delete('sort_by');

  // loop the FormData entries for filters
  formData.forEach((value, key) => {
    // append the filter parameters to the searchParams object
    searchParams.append(key, value);
  });

  if (sortValue) {
    searchParams.append('sort_by', sortValue);
  }

  // create new URL with the search parameters
  url.search = searchParams.toString();
  window.location.href = url.toString();
}

function clearFiltersForm() {
  const url = new URL(window.location.href);
  // remove all query parameters
  url.search = '';
  window.location.href = url.href;
}

/* menga menu - sublinks image on hover  */
document.addEventListener("DOMContentLoaded", function() {
  const linksWithImages = document.querySelectorAll('a[data-image-index]');

  linksWithImages.forEach(function(link) {
    link.addEventListener('mouseover', function() {
      const imageIndex = link.getAttribute('data-image-index');
      const image = document.getElementById(imageIndex);
      if (image) {
        image.style.display = 'block';
        image.style.opacity = 1;
      }
    });

    link.addEventListener('mouseout', function() {
      const imageIndex = link.getAttribute('data-image-index');
      const image = document.getElementById(imageIndex);
      if (image) {
        image.style.opacity = 0;
        setTimeout(() => { image.style.display = 'none'; }, 300); 
      }
    });
  });
});

/* product page - thumbnail buttons */

function nextImage() {
  const thumbnails = Array.from(document.querySelectorAll('.product-gallery__thumbnail'));
  const currentIndex = thumbnails.findIndex(thumbnail => thumbnail.getAttribute('aria-current') === 'true');
  const nextIndex = currentIndex - 1 >= 0 ? currentIndex - 1 : thumbnails.length - 1;
  thumbnails[nextIndex].click();
}

function prevImage() {
  const thumbnails = Array.from(document.querySelectorAll('.product-gallery__thumbnail'));
  const currentIndex = thumbnails.findIndex(thumbnail => thumbnail.getAttribute('aria-current') === 'true');
  const prevIndex = (currentIndex + 1) % thumbnails.length;
  thumbnails[prevIndex].click();
}

